import React from 'react';
import { navigate } from '@reach/router';

import { Container } from './styles';
import ButtonGroup from '../ButtonGroup';
import i18n from '../../i18n';

interface IComponentProps {
  companyId?: number;
  isOwnerOrSupport?: boolean;
  isAdvancedAdmin?: boolean;
}

const InnerNav: React.FC<IComponentProps> = ({
  companyId,
  isOwnerOrSupport,
  isAdvancedAdmin,
}) => {
  const adminItems = [
    {
      title: i18n.t('members', { ns: 'companyManagement' }),
      link: `/t/${companyId}/admin/members`,
    },
    {
      title: i18n.t('structure', { ns: 'companyManagement' }),
      link: `/t/${companyId}/admin/roles`,
    },
    {
      title: i18n.t('projects', { ns: 'companyManagement' }),
      link: `/t/${companyId}/admin/project/list`,
    },
    {
      title: i18n.t('sms-panel', { ns: 'companyManagement' }),
      link: `/t/${companyId}/admin/sms-panel`,
    },
    {
      title: i18n.t('documents', { ns: 'companyManagement' }),
      link: `/t/${companyId}/admin/documents`,
    },
  ];

  const advancedAdminItems =
    isAdvancedAdmin || isOwnerOrSupport
      ? [
          {
            title: i18n.t('templates', { ns: 'companyManagement' }),
            link: `/t/${companyId}/admin/template/list`,
          },
          {
            title: i18n.t('permissionSchemes', { ns: 'companyManagement' }),
            link: `/t/${companyId}/admin/permissionSchemes`,
          },
          {
            title: i18n.t('subCompany', { ns: 'companyManagement' }),
            link: `/t/${companyId}/admin/subCompany`,
          },
        ]
      : [];

  const ownerItems = isOwnerOrSupport
    ? [
        {
          title: i18n.t('pdp', { ns: 'companyManagement' }),
          link: `/t/${companyId}/admin/pdp`,
        },
      ]
    : [];

  return (
    <Container>
      <ButtonGroup
        items={[...adminItems, ...advancedAdminItems, ...ownerItems].reduce(
          (current, item) => {
            current[item.link] = item.title;
            return current;
          },
          {}
        )}
        selected={window.location.pathname}
        onSelect={(url) => navigate(url)}
        gap={'20px'}
      />
    </Container>
  );
};

export default InnerNav;
